import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { CopyBlock, dracula } from "react-code-blocks";

const AnimationScriptPanel = ({ animationScript, onClose }) => {
  return (
    <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, fontSize: '2em', height: '50%', width:'40%', padding: 2, backgroundColor: 'black', color: 'white', overflowY: 'scroll' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h5" gutterBottom>
          Animation Script
        </Typography>
        <Button variant="contained" color="secondary" onClick={onClose}>
          Close
        </Button>
      </Box>
      <CopyBlock text={animationScript} language="javascript" theme={dracula} />
    </Paper>
  );
};

export default AnimationScriptPanel;
